// Includes both staging and local. Production can either have this unset or
// set to something else, but for safety purposes prefer empty value to fallback
// to production.
const TEST_ENV = "test";

export const isTestEnv = (): boolean => {
  return process.env.REACT_APP_BUILD_ENV === TEST_ENV;
};
